<pre>{{ button.routerLink?.length }}</pre>

<ng-container *ngIf="!noLink">
  <a *ngIf="!button?.routerLink?.length && button?.url" [href]="button.url" [target]="target" [ngClass]="cssClasses">
    <span *ngIf="showText">{{ button.text }}</span>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
  <a
    [ngClass]="cssClasses"
    *ngIf="button?.routerLink?.length"
    [routerLink]="button.routerLink"
    [routerLinkActive]="routerLinkActive"
    [queryParams]="queryParams"
    [fragment]="fragment"
    [routerLinkActiveOptions]="routerLinkActiveOptions"
  >
    <span *ngIf="showText">{{ button.text }}</span>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<span *ngIf="noLink">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</span>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
